import { useLazyQuery } from "@apollo/client";
import { QUERY_GET_FORMATTED_INBOUND_RESOURCE_DATA } from "./constants";
import { Json } from "@towersystems/roam-common/lib/shared-types";
import React from "react";

export const useGetFormattedInboundRetailerDataForResource = () => {
  const [q, { loading }] = useLazyQuery<{
    getFormattedInboundRetailerDataForResource: Json;
  }>(QUERY_GET_FORMATTED_INBOUND_RESOURCE_DATA);

  const handleGetData = React.useCallback(
    async (resourceType: string, resourceId: string) => {
      const result = await q({
        variables: {
          resourceId,
          resourceType,
        },
      });

      if (result.data?.getFormattedInboundRetailerDataForResource) {
        return result.data.getFormattedInboundRetailerDataForResource;
      } else {
        throw new Error("Failed to send inbound to retailer");
      }
    },
    [q]
  );

  return {
    loading,
    getFormattedResourceData: handleGetData,
  };
};
